// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BRCM","controls":"styles_controls__3My_O","charLimit":"styles_charLimit__2y1xO","input":"styles_input__9vdNn","send":"styles_send__3mtAW"};